import React from 'react';
import { motion } from 'framer-motion';
import side1 from '../img/ZED.jpg'; 

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <motion.div 
          className="about-image"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img src={side1} alt="About Mamy Brand" />
        </motion.div>

        <motion.div 
          className="about-content"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.h3
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            عن مصنع وبراند MAMY
          </motion.h3>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            نحن مصنع وبراند مامي المتخصص في تصنيع وإنتاج أحدث صيحات الموضة والأزياء بجودة عالية تنافس الماركات العالمية. نؤمن بأن الأناقة تبدأ من جودة الخامات ودقة التصنيع، لذا نقدم لك تشكيلة مميزة تعكس ذوقك وتلبي احتياجاتك بأفضل الأسعار.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <a 
              href="https://www.facebook.com/share/18pYfJj69D/?mibextid=wwXIfr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="read-more-btn"
            >
              تابعنا على الفيسبوك
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;